import React, { ReactNode } from "react";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { useI18n } from "@/hooks/useI18n";
import dayjs from "dayjs";

interface LocaleProviderProps {
  children: ReactNode;
}

const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const { currentLanguage } = useI18n();

  // 根据当前语言设置 Antd locale
  const antdLocale = currentLanguage === "en-US" ? enUS : zhCN;

  // 根据当前语言设置 dayjs locale
  React.useEffect(() => {
    if (currentLanguage === "en-US") {
      dayjs.locale("en");
    } else {
      dayjs.locale("zh-cn");
    }
  }, [currentLanguage]);

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: { colorPrimary: "#37AEB9" },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default LocaleProvider;
